// extracted by mini-css-extract-plugin
export default {"textContainer":"termsConditions_textContainer__7H4Af","overlay":"termsConditions_overlay__nyclx"};